import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-16 px-4 bg-brand-dark border-y border-brand-accent/20" data-id="element-101">
      <div className="max-w-3xl mx-auto text-center" data-id="element-102">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-brand-accent rounded-full mb-6 shadow-lg" data-id="element-103">
          <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-104" />
        </div>

        <h2 className="text-2xl md:text-4xl font-black mb-6 text-brand-accent neon-glow" data-id="element-105">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-lg md:text-xl font-medium space-y-3 mb-8 text-gray-300" data-id="element-106">
          <p data-id="element-107">Abrís los tomos. Los usás en el aula.</p>
          <p data-id="element-108">Si en 7 días no es lo que esperabas:</p>
          <p className="text-2xl md:text-3xl font-black text-brand-accent bg-brand-card inline-block px-4 py-2 rounded-lg border border-brand-accent/20" data-id="element-109">
            devolución del 100%
          </p>
          <p data-id="element-110">sin formularios, sin drama.</p>
        </div>

        <p className="text-sm md:text-base text-gray-500 font-semibold bg-brand-card inline-block px-4 py-1.5 rounded-full border border-white/10" data-id="element-111">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}